import { BTable } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBTable = createEgBootstrapProxy("EgBTable", BTable);
